import { DefaultService } from '@/services/DefaultService';


export default class GradeLinhaService extends DefaultService {
    constructor(http, router, env) {
		super(http, router, env);
	}

    findAllGradeLinhasByProdutoCombo(idproduto, limit, ...params) {
        return this._http.get(`${this._env}/sales/gridrow/product/${idproduto}/combo.json?limit=${limit}&param=${params}`, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw new Error('Problems while jobs are loading');
        });
    }


}